import React from 'react';
import SocialIcon from "../social-icon";
import {renderRichText} from "gatsby-source-contentful/rich-text";
import {getImage} from "../../contentful/data-provider";

function HeaderWithImageAndSocials(props) {
    return (
        <section className="header-section mb-lg-5 pb-5">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-sm-12 order-2 order-md-1">
                        <div className="row">
                            <div className="col-lg-10 col-12">
                                {props.content.smallTitle &&
                                    <div className={'h1-subtitle'}>{props.content.smallTitle}</div>
                                }
                                <h1>{props.content.title}</h1>
                            </div>
                        </div>
                        {props.content.body &&
                            <div className="row">
                                <div className="col-lg-10 col-12">
                                    { props.content.body && renderRichText(props.content.body) }
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-lg-10 col-12">
                                <a href={props.content.ctaUrl} target={props.content.isExternal ? '_blank' : '_self'} className="more mt-2 mb-5 d-block text-decoration-none">
                                    <i className={'fas fa-arrow-right'}/>
                                    {props.content.ctaText}
                                </a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="social">
                                    {props.content.socalLinks.map((element, index) => {
                                        return(
                                            <SocialIcon
                                                key={index} image={element.image.url}
                                                url={element.url} title={element.image.title}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 text-right order-1 order-md-2">
                        <link rel="preload"
                              as="image"
                              href={getImage(props.content.image).url}
                              imageSrcSet={`${getImage(props.content.image).url} 800w`}/>
                        <div className={'image'}>
                            <img src={getImage(props.content.image).url} alt={getImage(props.content.image).title}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeaderWithImageAndSocials;
